import { Fragment } from "react";
import { Flex, Text, Input } from "@theorgchartdev/storybook";
import { sectionTitles } from "../../../../Navigation/Header/WebLinkMenu/WebLinkUtils";
import { GetWSMgr } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";

export const LinkSection = ({ linkConfig, setUrlParamsMgr }) => {
  const SetLink = value => {
    setUrlParamsMgr(prevState => ({ ...prevState, link: value }));
  };
  const handleCopy = e => {
    navigator.clipboard.writeText(linkConfig);
    const wsMgr = GetWSMgr();
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker.ReportEvent("chart_mode.share_link.saved");
  };

  return (
    <Fragment>
      <Flex direction={"column"} gap={"8px"}>
        <Text size={"small"} modifier={"bold"}>
          {appstr(sectionTitles.link)}
        </Text>
        <Flex direction={"row"} justifyContent={"space-between"}>
          <div style={{ width: "85%" }}>
            <Input
              size={"small"}
              value={linkConfig}
              onChange={e => SetLink(e.target.value)}
              dataTestId={"weblink-link-input"}
            />
          </div>
          <div style={{ cursor: "pointer" }}>
            <Text
              size={"small"}
              modifier={"medium"}
              colorModifier={"theme"}
              onClick={e => handleCopy()}
              dataTestId={"weblink-copy-link-btn"}
            >
              {appstr("copylink")}
            </Text>
          </div>
        </Flex>
      </Flex>
    </Fragment>
  );
};
